import { motion } from "framer-motion";
import { Reveal, EASE } from "@/components/Reveal";

const MARKETS = [
  { name: "India", status: "Now Serving", active: true },
  { name: "GCC", status: "On the Roadmap", active: false },
  { name: "International Markets", status: "On the Roadmap", active: false },
];

export default function Global() {
  return (
    <section id="global" data-testid="global-section" className="relative overflow-hidden bg-cream py-24 md:py-32">
      <svg
        aria-hidden
        viewBox="0 0 1200 400"
        className="pointer-events-none absolute inset-x-0 top-1/2 hidden w-full -translate-y-1/2 opacity-60 lg:block"
      >
        <motion.path
          d="M 100 320 Q 600 40 1100 240"
          fill="none"
          stroke="#C8A97E"
          strokeWidth="1.5"
          strokeDasharray="6 8"
          initial={{ pathLength: 0 }}
          whileInView={{ pathLength: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 2.4, ease: "easeInOut" }}
        />
      </svg>

      <div className="relative mx-auto max-w-7xl px-5 md:px-10">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-gold">
            The Vision
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-4xl font-heading text-5xl leading-[1.05] text-forest sm:text-6xl lg:text-7xl">
            Born in India.
            <br />
            <span className="italic text-forest-light">Designed for the World.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-charcoal/70 md:text-lg">
            MAHIRA begins its journey in India with a vision to bring authentic,
            premium Indian agro-products to customers across India — and
            eventually, the world.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-12 flex flex-wrap gap-4">
            {MARKETS.map((m) => (
              <div
                key={m.name}
                data-testid={`market-chip-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
                className={`flex items-center gap-3 rounded-full border px-6 py-3.5 ${
                  m.active
                    ? "border-forest bg-forest text-ivory"
                    : "border-forest/20 bg-white/50 text-forest"
                }`}
              >
                <span
                  className={`h-2 w-2 rounded-full ${m.active ? "bg-gold" : "bg-forest/30"}`}
                />
                <span className="text-sm font-semibold">{m.name}</span>
                <span
                  className={`text-[10px] font-semibold uppercase tracking-[0.2em] ${
                    m.active ? "text-gold" : "text-charcoal/45"
                  }`}
                >
                  {m.status}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
